module.exports = {
	"network": {
		"port": 8333
	},
	"rpc": {
		"rpcport": 8332
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/ports.json
 ** module id = 45
 ** module chunks = 0
 **/